import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Option } from '@common-fe/common-fe';

import { ALL_KEY } from '@/common/constants';
import { MoneyTransferStatus } from '@/modules/investments/investments.types';



const useMoneyTransferOptions = () => {
  const { t } = useTranslation();
  const list = useMemo<Option[]>(() => [
    {
      key: ALL_KEY,
      title: t('All'),
      
    },{
      key: MoneyTransferStatus.CreatedInternal,
      title: t('Processing'),
    
    },{
      key: MoneyTransferStatus.Paid,
      title: t('Completed'),
    }] ,[t] );
  return list;
};

export default useMoneyTransferOptions;